import React from 'react'
import Cookies from 'universal-cookie';
const Logout = () => {
    const cookiess = new Cookies();
    cookiess.remove('wtkn');
    cookiess.remove('csrf');
    cookiess.remove('client');
    window.location.replace(`https://login.metincevener.com/login?redirect=react&${window.location.href}`);
  return (
    <div>Logout</div>
  )
}

export default Logout